module.exports = __webpack_public_path__ + "static/media/icon-line-movie.794180e1.svg";